import React, { useCallback, useState, useEffect } from "react";
import NavBar from "../../components/NavBar/NavBar";
import MenuService from "../../services/menuService";
import UserService from "../../services/userService";
import WeatherService from "../../services/weatherService";

const NavBarContainer = () => {
  const userId = localStorage.getItem("userId");
  const screenname = localStorage.getItem("screenname");
  const [menus, setMenus] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [itemSubmenus, setItemSubmenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [weather, setWeather] = useState(null);

  const navigation = useCallback(async () => {
    try {
      const response = await MenuService.getUserMenus(userId);

      const { menus, menuItems, itemSubmenus } = response;
      setMenus([...menus]);
      setMenuItems([...menuItems]);
      setItemSubmenus(itemSubmenus);
    } catch (error) {
      setError("Failed to fetch data: " + error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  const fetchUserImage = useCallback(async () => {
    setLoading(true);
    try {
      const photo = await UserService.getUserImage(userId);

      if (photo) {
        setPhoto(photo);
      } else {
        setPhoto(null);
      }
    } catch (error) {
      console.error("Error al obtener la imagen.", error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    navigation();
    fetchUserImage();
  }, [navigation, fetchUserImage]);

  useEffect(() => {
    window.addEventListener("menus:refresh", navigation);
    return () => window.removeEventListener("menus:refresh", navigation);
  }, [navigation]);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const weatherData = await WeatherService.getWeather();
        setWeather(weatherData.weather);
      } catch (error) {
        console.error("Error fetching weather data", error);
      }
    };
    fetchWeather();
  }, []);

  return (
    <div>
      <NavBar
        menus={menus}
        menuItems={menuItems}
        itemSubmenus={itemSubmenus}
        loading={loading}
        error={error}
        photo={photo}
        screenname={screenname}
        weather={weather}
      />
    </div>
  );
};

export default NavBarContainer;
